import { Routes } from "@angular/router";
import Landing1Component from "./pages/landing-1/landing-1.component";

export const routes: Routes = [
  {
    path: "",
    component: Landing1Component,
  },
  {
    path: "**",
    redirectTo: "",
  },
];
